if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // dispatch cart:error
            document.dispatchEvent(
              new CustomEvent('cart:error', {
                detail: {
                  source: this.dataset.source,
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message
                }
              })
            );
            // dispatch cart:error
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // dispatch variant:add
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get('id')
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source
              }
            })
          );
          // dispatch variant:add

          fetch(`${routes.cart_url}.js`)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state)

              // dispatch cart:change for the entire basket
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: parsedState,
                    sectionId: this.dataset.source
                  }
                })
              );
              // dispatch cart:change for the entire basket

            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            });

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}



// ======================================================
// SIZE GUIDE
//
// CSV想定:
//
// madisonblue,00,01,02
// JP,7,9,11
// A : Waist,72.2,74.2,77.2
// B : Hip,88.2,91,93.6
// C : Hem,94.4,97.4,100.4
// D : Length,69,70.5,72
//
// ・JAPAN / FR / EN サイズ変換
// ・CM / INCH 単位変換
// ======================================================

(function () {

  // ======================================================
  // 国別サイズ変換
  //
  // 元データ = JP
  // ======================================================

  const sizeLanguageMap = {

    JAPAN: {
      "5": "5",
      "7": "7",
      "9": "9",
      "11": "11",
      "13": "13",
      "S": "S",
      "M": "M",
      "L": "L",
    },

    FR: {
      "5": "32",
      "7": "34",
      "9": "36",
      "11": "38",
      "13": "40",
      "S": "46",
      "M": "48",
      "L": "50",
    },

    EN: {
      "5": "0",
      "7": "2",
      "9": "4",
      "11": "6",
      "13": "8",
      "S": "36",
      "M": "38",
      "L": "40",
    },

  };

  // ======================================================
  // JAPAN 表示時の採寸項目名
  // ======================================================

  const measurementLabelMap = {

    JACKET: {
      Shoulder: "肩幅",
      Chest: "身幅",
      Sleeve: "袖丈",
      Length: "着丈",
    },

    COAT: {
      Shoulder: "肩幅",
      Chest: "身幅",
      Sleeve: "袖丈",
      Length: "着丈",
    },

    PANTS: {
      Waist: "ウエスト",
      Hip: "ヒップ",
      Hem: "裾幅",
      Length: "着丈",
    },

    "DRESSES": {
      Shoulder: "肩幅",
      Chest: "身幅",
      Waist: "ウエスト",
      Sleeve: "袖丈",
      Length: "着丈",
    },

    "ONE-PIECE": {
      Shoulder: "肩幅",
      Chest: "身幅",
      Waist: "ウエスト",
      Sleeve: "袖丈",
      Length: "着丈",
    },

    "SHIRT/BLOUSE": {
      Shoulder: "肩幅",
      Chest: "身幅",
      Sleeve: "袖丈",
      Length: "着丈",
    },

    SKIRTS: {
      Waist: "ウエスト",
      Hip: "ヒップ",
      Hem: "裾幅",
      Length: "着丈",
    },

    SKIRT: {
      Waist: "ウエスト",
      Hip: "ヒップ",
      Hem: "裾幅",
      Length: "着丈",
    },

    "CUT&SEWN": {
      Shoulder: "肩幅",
      Chest: "身幅",
      Sleeve: "袖丈",
      Length: "着丈",
    },

    BELT: {
      Length: "全長",
      Width: "幅",
    },

    BAG: {
      Height: "タテ",
      Width: "ヨコ",
      Depth: "マチ",
    },

    CAP: {
      Head: "頭周り",
    },

    KNIT: {
      Shoulder: "肩幅",
      Chest: "身幅",
      Sleeve: "袖丈",
      Length: "着丈",
    },


  };


  // ======================================================
  // JAPAN / FR / EN
  // ======================================================

  function changeSizeGuideLanguage(section, language) {

    const sizeTable =
      section.querySelector(".size-guide-table");

    if (!sizeTable) return;


    const lang =
      String(language)
        .trim()
        .toUpperCase();


    const conversion =
      sizeLanguageMap[lang];

    if (!conversion) return;


    sizeTable.dataset.language = lang;


    // ================================================
    // JP / FR / EN 行を取得
    // ================================================

    const rows =
      sizeTable.querySelectorAll("tbody tr");

    let languageRow = null;


    rows.forEach(function (row) {

      const firstCell =
        row.querySelector("th, td");

      if (!firstCell) return;


      const value =
        firstCell.textContent
          .trim()
          .toUpperCase();


      if (
        value === "JP" ||
        value === "JA" ||
        value === "FR" ||
        value === "EN" ||
        row.dataset.languageRow === "true"
      ) {
        languageRow = row;
      }

    });


    // ================================================
    // JP / FR / EN 行が存在する場合だけ
    // 言語・サイズ変換を行う
    // ================================================

    if (languageRow) {

      languageRow.dataset.languageRow = "true";


      const cells =
        languageRow.querySelectorAll(
          "th, td"
        );


      // ================================================
      // JP / FR / EN 表示
      // ================================================

      if (cells[0]) {

        cells[0].textContent =
          lang === "JAPAN"
            ? "JP"
            : lang;

      }


      // ================================================
      // サイズ変換
      // ================================================

      for (
        let i = 1;
        i < cells.length;
        i++
      ) {

        const cell =
          cells[i];


        // 元JP値保存
        if (
          !cell.hasAttribute(
            "data-japan-value"
          )
        ) {

          cell.dataset.japanValue =
            cell.textContent.trim();

        }


        const japanValue =
          (
            cell.dataset.japanValue ||
            ""
          )
            .trim()
            .toUpperCase();


        if (
          Object.prototype.hasOwnProperty.call(
            conversion,
            japanValue
          )
        ) {

          cell.textContent =
            conversion[japanValue];

        } else {

          cell.textContent =
            cell.dataset.japanValue;

        }

      }

    }

    changeMeasurementLabels(
      section,
      lang
    );



    // ================================================
    // 言語と単位を連動
    //
    // JAPAN → CM
    // FR    → CM
    // EN    → INCH
    //
    // ※ JP / FR / EN 行がなくてもここは実行する
    // ================================================

    let unitButton;


    if (lang === "EN") {

      unitButton =
        section.querySelector(
          ".js-changeUnit.inch"
        );

    } else {

      unitButton =
        section.querySelector(
          ".js-changeUnit.cm"
        );

    }


    if (unitButton) {

      changeSizeGuideUnit(
        section,
        unitButton
      );

    }

  }


  // ======================================================
  // 採寸項目名を JAPAN / FR / EN に応じて変更
  // ======================================================

  function changeMeasurementLabels(section, language) {

    const sizeTable = section.querySelector(".size-guide-table");
    if (!sizeTable) return;

    const type = String(
      section.dataset.sizeguideType || ""
    ).trim().toUpperCase();

    const labelMap = measurementLabelMap[type] || {};

    sizeTable.querySelectorAll("tbody tr").forEach(function (row) {

      // JP / FR / EN 行の見出しは changeSizeGuideLanguage で更新する
      if (row.dataset.languageRow === "true") return;

      const firstCell = row.querySelector("th, td");
      if (!firstCell) return;

      // 初期値を保存
      if (!firstCell.hasAttribute("data-original-label")) {
        firstCell.dataset.originalLabel = firstCell.textContent.trim();
      }

      const originalLabel = firstCell.dataset.originalLabel;

      // A : Shoulder などのプレフィックスを分離
      const match = originalLabel.match(/^([A-Z]\s*:\s*)(.+)$/i);

      const prefix = match ? match[1] : "";
      const label = (match ? match[2] : originalLabel).trim();

      // 英語・日本語のどちらからでも英語キーを取得
      const englishKey = Object.keys(labelMap).find((key) => {
        return (
          key.toUpperCase() === label.toUpperCase() ||
          labelMap[key] === label
        );
      });

      // 翻訳対象外なら初期値を維持
      if (!englishKey) {
        firstCell.textContent = originalLabel;
        return;
      }

      if (language === "JAPAN") {
        firstCell.textContent = prefix + labelMap[englishKey];
      } else {
        firstCell.textContent = prefix + englishKey;
      }

    });

  }


  // ======================================================
  // CM / INCH
  // ======================================================

  function changeSizeGuideUnit(
    section,
    unitButton
  ) {

    const unitButtons =
      section.querySelectorAll(
        ".js-changeUnit"
      );


    const sizeTable =
      section.querySelector(
        ".size-guide-table"
      );


    if (!sizeTable) return;


    // ==================================================
    // active
    // ==================================================

    unitButtons.forEach(function (button) {

      button.classList.remove(
        "is-current"
      );

    });


    unitButton.classList.add(
      "is-current"
    );


    const isInch =
      unitButton.classList.contains(
        "inch"
      );


    sizeTable.dataset.unit =
      isInch
        ? "inch"
        : "cm";


    // ==================================================
    // 各行を見る
    //
    // A : Waist
    // B : Hip
    // C : Hem
    // D : Length
    // ==================================================

    sizeTable
      .querySelectorAll("tbody tr")
      .forEach(function (row) {

        const cells =
          row.querySelectorAll(
            "th, td"
          );


        if (!cells.length) return;


        const heading =
          cells[0]
            .textContent
            .trim()
            .toUpperCase();


        // ------------------------------------------------
        // A〜Eで始まる行のみ対象
        //
        // A : Waist
        // B : Hip
        // ...
        // ------------------------------------------------

        const isMeasurementRow =
          /^[A-E]\s*:/.test(
            heading
          );


        if (!isMeasurementRow) {
          return;
        }


        // ------------------------------------------------
        // 2列目以降を変換
        // ------------------------------------------------

        for (
          let i = 1;
          i < cells.length;
          i++
        ) {

          const cell =
            cells[i];


          // ============================================
          // 元CM値保存
          // ============================================

          if (
            !cell.hasAttribute(
              "data-cm-value"
            )
          ) {

            const originalValue =
              cell.textContent.trim();

            if (!originalValue) {
              continue;
            }

            // 数値化せず、そのまま保存
            cell.dataset.cmValue =
              originalValue;

          }


          // ============================================
          // 保存した元CM値
          // ============================================

          const cmValue =
            cell.dataset.cmValue;

          if (!cmValue) {
            continue;
          }


          // ============================================
          // INCH / CM
          // ============================================

          if (isInch) {

            // 文字列内のすべての数値をインチ換算
            // 例:
            // 56       → 22.0
            // 56～66   → 22.0～26.0
            // 56〜66   → 22.0〜26.0
            // 56-66    → 22.0-26.0
            cell.textContent =
              cmValue.replace(
                /\d+(?:\.\d+)?/g,
                function (value) {

                  return (
                    Number.parseFloat(value) / 2.54
                  ).toFixed(1);

                }
              );

          } else {

            // CMに戻す
            cell.textContent =
              cmValue;

          }

        }

      });

  }



  // ======================================================
  // 初期化
  // ======================================================

  function initializeSizeGuide(
    section
  ) {

    if (!section) return;


    const select =
      section.querySelector(
        ".sizeguide-select"
      );


    const cmButton =
      section.querySelector(
        ".js-changeUnit.cm"
      );


    const inchButton =
      section.querySelector(
        ".js-changeUnit.inch"
      );


    const path =
      window.location.pathname
        .toLowerCase();


    // ==================================================
    // 初期値
    // ==================================================

    let initialLanguage =
      "JAPAN";


    let initialUnitButton =
      cmButton;


    // ==================================================
    // URL判定
    // ==================================================

    if (
      path.startsWith("/fr") ||
      path.includes("/fr-")
    ) {

      initialLanguage =
        "FR";

      initialUnitButton =
        cmButton;

    }

    else if (
      path.startsWith("/en") ||
      path.includes("/en-") ||
      path.includes("-us/")
    ) {

      initialLanguage =
        "EN";

      initialUnitButton =
        inchButton;

    }


    // ==================================================
    // SELECT
    // ==================================================

    if (select) {

      select.value =
        initialLanguage;

    }


    // ==================================================
    // JAPAN / FR / EN
    // ==================================================

    changeSizeGuideLanguage(
      section,
      initialLanguage
    );


    // ==================================================
    // CM / INCH
    // ==================================================

    if (initialUnitButton) {

      changeSizeGuideUnit(
        section,
        initialUnitButton
      );

    }

  }



  // ======================================================
  // 全SIZE GUIDE初期化
  // ======================================================

  function initializeAllSizeGuides(
    root
  ) {

    const targetRoot =
      root || document;


    targetRoot
      .querySelectorAll(
        ".size-guide-drawer__section"
      )
      .forEach(function (section) {

        initializeSizeGuide(
          section
        );

      });

  }



  // ======================================================
  // JAPAN / FR / EN変更
  // ======================================================

  document.addEventListener(
    "change",
    function (event) {

      if (
        !event.target.matches(
          ".sizeguide-select"
        )
      ) {
        return;
      }


      const select =
        event.target;


      const section =
        select.closest(
          ".size-guide-drawer__section"
        );


      if (!section) return;


      changeSizeGuideLanguage(
        section,
        select.value
      );

    }
  );



  // ======================================================
  // CM / INCHクリック
  // ======================================================

  document.addEventListener(
    "click",
    function (event) {

      const unitButton =
        event.target.closest(
          ".js-changeUnit"
        );


      if (!unitButton) return;


      const section =
        unitButton.closest(
          ".size-guide-drawer__section"
        );


      if (!section) return;


      changeSizeGuideUnit(
        section,
        unitButton
      );

    }
  );



  // ======================================================
  // 初回読み込み
  // ======================================================

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      function () {

        initializeAllSizeGuides(
          document
        );

      }
    );

  } else {

    initializeAllSizeGuides(
      document
    );

  }



  // ======================================================
  // Shopify Theme Editor
  // ======================================================

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      initializeAllSizeGuides(
        event.target
      );

    }
  );

})();

document.addEventListener('DOMContentLoaded', () => {
  const tables = document.querySelectorAll('.size-guide-table');

  tables.forEach((table) => {
    const cells = table.querySelectorAll('th, td');

    cells.forEach((cell) => {
      cell.addEventListener('mouseenter', () => {
        const row = cell.parentElement;
        const cellIndex = Array.from(row.children).indexOf(cell);

        // 一番左の列は対象外
        if (cellIndex === 0) return;

        table
          .querySelectorAll(
            `tr > *:nth-child(${cellIndex + 1})`
          )
          .forEach((target) => {
            target.classList.add('is-column-hover');
          });
      });

      cell.addEventListener('mouseleave', () => {
        table
          .querySelectorAll('.is-column-hover')
          .forEach((target) => {
            target.classList.remove('is-column-hover');
          });
      });
    });
  });
});
